/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Command to search real estate properties by address
 * @export
 * @interface SearchRealEstatesCommand
 */
export interface SearchRealEstatesCommand {
    /**
     * Search string to filter real estates by address
     * @type {string}
     * @memberof SearchRealEstatesCommand
     */
    searchString?: string;
    /**
     * Maximum number of results to return
     * @type {number}
     * @memberof SearchRealEstatesCommand
     */
    maxResultCount?: number;
}

/**
 * Check if a given object implements the SearchRealEstatesCommand interface.
 */
export function instanceOfSearchRealEstatesCommand(value: object): value is SearchRealEstatesCommand {
    return true;
}

export function SearchRealEstatesCommandFromJSON(json: any): SearchRealEstatesCommand {
    return SearchRealEstatesCommandFromJSONTyped(json, false);
}

export function SearchRealEstatesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRealEstatesCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
        'maxResultCount': json['maxResultCount'] == null ? undefined : json['maxResultCount'],
    };
}

export function SearchRealEstatesCommandToJSON(json: any): SearchRealEstatesCommand {
    return SearchRealEstatesCommandToJSONTyped(json, false);
}

export function SearchRealEstatesCommandToJSONTyped(value?: SearchRealEstatesCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchString': value['searchString'],
        'maxResultCount': value['maxResultCount'],
    };
}

